import { render } from "./component-form.vue?vue&type=template&id=210e6cc9"
import script from "./component-form.vue?vue&type=script&lang=js"
export * from "./component-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__